import { render, staticRenderFns } from "./table.position.component.vue?vue&type=template&id=18f043c0&scoped=true"
import script from "./table.position.component.vue?vue&type=script&lang=js"
export * from "./table.position.component.vue?vue&type=script&lang=js"
import style0 from "./table.position.component.vue?vue&type=style&index=0&id=18f043c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f043c0",
  null
  
)

export default component.exports